import React, { useState, useEffect } from 'react';
import { getOrdersByDestination, markOrderReady } from '../../services/api';

function BarDisplayScreen() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [ws, setWs] = useState(null);

  const fetchOrders = async () => {
    try {
      const data = await getOrdersByDestination('bar');
      setOrders(data);
    } catch (err) {
      setError('Failed to fetch orders. Please try again.');
      console.error('Fetch orders error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();

    // WebSocket setup
    const websocket = new WebSocket(`ws://${window.location.host}/ws/bar`);
    setWs(websocket);

    websocket.onopen = () => {
      console.log('WebSocket connected for bar display');
    };

    websocket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (message.type === 'new_order' || message.type === 'order_update') {
        console.log('Received new order/update via WebSocket:', message);
        fetchOrders(); // Re-fetch all orders to update the display
      }
    };

    websocket.onclose = () => {
      console.log('WebSocket disconnected for bar display');
    };

    websocket.onerror = (err) => {
      console.error('WebSocket error:', err);
    };

    return () => {
      websocket.close();
    };
  }, []);

  const handleMarkReady = async (orderId) => {
    try {
      await markOrderReady(orderId);
      fetchOrders(); // Refresh orders after marking one as ready
    } catch (err) {
      setError('Failed to mark order as ready.');
      console.error('Mark ready error:', err);
    }
  };

  if (loading) return <div>Loading bar orders...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div>
      <h2>Bar Display</h2>
      {orders.length === 0 ? (
        <p>No pending orders for the bar.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {orders.map((order) => (
            <div key={order.order_id} style={{ border: '1px solid #ccc', padding: '15px', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
              <h3>Order #{order.order_id} - Table {order.table_number}</h3>
              <p>Waiter: {order.waiter_name}</p>
              <p>Status: {order.status}</p>
              <p>Created At: {new Date(order.created_at).toLocaleString()}</p>
              <h4>Items:</h4>
              <ul>
                {order.items.map((item, index) => (
                  <li key={index}>
                    {item.quantity}x {item.name} {item.observation && `(${item.observation})`}
                  </li>
                ))}
              </ul>
              {order.status !== 'ready' && (
                <button onClick={() => handleMarkReady(order.order_id)} style={{ padding: '8px 15px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                  Mark as Ready
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default BarDisplayScreen;
